import { render, staticRenderFns } from "./ConsolidatedClosureList.vue?vue&type=template&id=43787352"
import script from "./ConsolidatedClosureList.js?vue&type=script&lang=js&external"
export * from "./ConsolidatedClosureList.js?vue&type=script&lang=js&external"
import style0 from "./ConsolidatedClosureList.vue?vue&type=style&index=0&id=43787352&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports